const SAFE_EXTERNAL_PROTOCOLS: ReadonlyArray<string> = ['http:', 'https:'];
const PHONE_NUMBER_PATTERN = /^\+?[0-9\s().-]{2,25}$/;
const INTERNAL_PATH_PATTERN = /^\/(?![/\\])/;
const ROOT_PATH = '/';

export function isSafeExternalUrl(url: string): boolean {
  if (!url) {
    return false;
  }

  try {
    return SAFE_EXTERNAL_PROTOCOLS.includes(new URL(url).protocol);
  } catch {
    return false;
  }
}

export function isPhoneNumber(value: string): boolean {
  return !!value && PHONE_NUMBER_PATTERN.test(value);
}

export function toSafeInternalPath(path: string): string {
  return path && INTERNAL_PATH_PATTERN.test(path) ? path : ROOT_PATH;
}
